<template>
  <div class="transfer-wrapper" @submit.prevent>
    <!-- 左侧内容 -->
    <div class="transfer__left">
      <!-- 头部搜索 -->
      <div class="transfer-header__wrapper">
        <h3>选择系统接口</h3>
        <div class="filter-wrapper">
          <el-input
            @keyup.enter.native="$_search"
            v-model.trim="searchKey"
            class="filter-keyword__input"
            placeholder="搜索ID、接口名称或ActionName"
          ></el-input>
          <a @click.stop="$_search" href="javascript:;" class="search__btn">
            <i class="el-icon-search"></i>
          </a>
        </div>
      </div>
      <!-- 可选择数据列表 -->
      <div class="table-list__wrapper">
        <el-table
          class="table-list__box"
          ref="standbyList"
          :data="dataList"
          v-loading="isLoading"
          :height="384"
          stripe
          tooltip-effect="dark"
          @select="$_selectRow"
          @select-all="$_selectAll"
        >
          <el-table-column type="selection" width="50"></el-table-column>

          <el-table-column
            v-for="column in columns"
            :key="column.key"
            :prop="column.key"
            :label="column.label"
            :width="column.width"
            :resizable="false"
            show-overflow-tooltip
          ></el-table-column>

          <div slot="empty">暂无数据</div>
        </el-table>
        <!-- 分页 -->
        <div class="pagination__wrapper">
          <cd-pagination
            ref="pager"
            :total="pagination.total"
            :currPage="pagination.pageNow"
            :pageSize="pagination.pageSize"
            @changepage="$_changeCurrent"
            @changesize="$_changeSize"
            :explainShow="false"
            @refresh="$_getApis"
          ></cd-pagination>
        </div>
      </div>
    </div>
    <!-- 右侧 -->
    <div class="transfer__right">
      <div class="transfer-header__wrapper">
        <h3>已选接口</h3>
        <el-button @click="$_clearAllSelected" class="clear-all__btn">清除已选项</el-button>
      </div>
      <!-- 已选列表 -->
      <div class="table-list__wrapper">
        <el-table
          class="table-list__box selected-list"
          ref="selectedList"
          :data="selectedList"
          :height="428"
          stripe
          @selection-change="$_selectedChange"
          tooltip-effect="dark"
        >
          <el-table-column type="selection" align="center" width="50"></el-table-column>

          <el-table-column
            v-for="column in columns"
            :key="column.key"
            :prop="column.key"
            :label="column.label"
            :width="column.width"
            :resizable="false"
            show-overflow-tooltip
          ></el-table-column>

          <span class="table__empty-text" slot="empty">←请在左边栏目中选择接口</span>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
const columns = [
  { key: "pid", label: "ID", width: 80 },
  { key: "apiName", label: "接口名称", width: 180 },
  { key: "actionName", label: "ActionName" }
];
export default {
  name: "transfer",
  props: {
    selecteds: { type: Array, default: [] }
  },
  data() {
    return {
      isLoading: false,
      searchKey: "",
      columns,
      dataList: [],
      pagination: {
        pageNow: 1,
        pageSize: 20,
        pages: 0,
        total: 0
      },
      standBySelecteds: [], // 左侧可选择数据 已选择项
      selectedList: [], // 已选择项
      selectecdTheSelected: [] // 选择已选项
    };
  },
  methods: {
    $_search() {
      this.pagination.pageNow = 1;
      this.$_getApis();
    },
    $_getApis() {
      this.isLoading = true;
      let postData = {
        status: 1,
        pageNow: this.pagination.pageNow,
        pageSize: this.pagination.pageSize
      };
      if (/^\d+$/.test(this.searchKey)) {
        // 搜索id
        Object.assign(postData, { pid: this.searchKey });
      } else {
        Object.assign(postData, { apiName: this.searchKey });
      }

      this.$service.post("queryPortPaging", postData).then(result => {
        if (result.$.checkResult(result, true)) {
          if (
            /^\d+$/.test(this.searchKey) === false &&
            result.data.rows.length === 0
          ) {
            delete postData.apiName;
            Object.assign(postData, { actionName: this.searchKey });
            this.$service.post("queryPortPaging", postData).then(_result => {
              this.isLoading = false;
              if (_result.$.checkResult(result, true)) {
                this.pagination.pages = _result.data.pages;
                this.pagination.total = _result.data.total;
                this.dataList = _result.data.rows.concat([]);
              }
            });
          } else {
            this.pagination.pages = result.data.pages;
            this.pagination.total = result.data.total;
            this.dataList = result.data.rows.concat([]);
            this.isLoading = false;
          }
        } else {
          this.isLoading = false;
        }
      });
    },
    // 切换每页size
    $_changeSize(page, size) {
      this.pagination.pageSize = size;
      this.pagination.pageNow = 1;
      this.$_getApis();
    },
    // 切换当前页
    $_changeCurrent(val) {
      this.pagination.pageNow = val;
      this.$_getApis();
    },
    // 单选行
    $_selectRow(selection, row) {
      this.standBySelecteds = selection.concat();
      if (selection.some(item => item.pid === row.pid)) {
        // 选中
        let index = this.selectedList.findIndex(item => item.pid === row.pid);
        if (!~index) {
          this.selectedList.push(row);
        }
      } else {
        // 取消勾选
        let index = this.selectedList.findIndex(item => item.pid === row.pid);
        if (~index) {
          this.selectedList.splice(index, 1);
        }
      }
    },
    // 全选
    $_selectAll(selection) {
      this.standBySelecteds = selection.concat();
      if (selection.length > 0) {
        // 全选
        selection.forEach(row => {
          let index = this.selectedList.findIndex(item => item.pid === row.pid);
          if (!~index) {
            this.selectedList.push(row);
          }
        });
      } else {
        // 取消全选
        this.dataList.forEach(row => {
          let index = this.selectedList.findIndex(item => item.pid === row.pid);
          if (~index) {
            this.selectedList.splice(index, 1);
          }
        });
      }
    },
    // 右侧列表部分,
    $_selectedChange(selection) {
      this.selectecdTheSelected = selection.concat([]);
    },
    // 清除已选项
    $_clearAllSelected() {
      this.selectecdTheSelected.forEach(item => {
        // 右侧数组删除已选项
        let index = this.selectedList.findIndex(row => row.pid === item.pid);
        if (~index) {
          this.selectedList.splice(index, 1);
        }
        // 判断左侧数据是否已勾选, 已勾选则取消
        let row = this.standBySelecteds.find(row => row.pid === item.pid);
        if (typeof row !== "undefined") {
          this.$refs.standbyList.toggleRowSelection(row);
        }
      });
      this.selectecdTheSelected.splice(0);
      // if (rows) {
      //   rows.forEach(row => {
      //     this.$refs.standbyList.toggleRowSelection(row);
      //   });
      // } else {
      //   this.$refs.standbyList.clearSelection();
      // }
    }
  },
  watch: {
    selectedList(val) {
      this.$emit("update:selecteds", val);
    }
  },

  created() {
    this.$_getApis();
    if (this.selecteds.length > 0) {
      this.selectedList = this.selecteds.concat();
    }
  }
};
</script>

<style lang="scss" scoped>
.transfer-wrapper {
  &::after {
    content: "";
    display: table;
    clear: both;
  }
  .transfer__left,
  .transfer__right {
    width: 600px;
    height: 470px;
    border: 1px solid #eee;
  }
  .transfer__left {
    float: left;
  }
  .transfer__right {
    float: right;
  }
  .transfer-header__wrapper {
    position: relative;
    height: 40px;
    color: #535353;
    background-color: #f5f6f7;
    h3 {
      padding-left: 20px;
      line-height: 40px;
      font-size: 12px;
    }
    .filter-wrapper,
    .clear-all__btn {
      position: absolute;
      right: 4px;
    }
    .filter-wrapper {
      top: 6px;
    }
    .filter-keyword__input {
      width: 240px;
    }
    .search__btn {
      position: absolute;
      right: 0px;
      top: 1px;
      display: block;
      font-size: 16px;
      width: 28px;
      height: 26px;
      text-align: center;
      color: #999;
    }

    .clear-all__btn {
      top: 5px;
      border-radius: 4px;
      background: linear-gradient(to right, #f87d5f, #f26a49);
      &:hover {
        background: linear-gradient(to right, #e17156, #cf583b);
      }
      &:focus {
        background: linear-gradient(to right, #de674b, #c94d2f);
      }
    }
  }
  .table__empty-text {
    color: #535353;
    padding-top: 100px;
    display: block;
    position: relative;
    background: url(~@/assets/images/icon-mascot.png) no-repeat top center;
  }
}
</style>

